import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ontos-count-hidden"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    _createTextVNode("(" + _toDisplayString(_ctx.count), 1),
    (_ctx.hidden)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, "+" + _toDisplayString(_ctx.hidden), 1))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createTextVNode(")", -1))
  ]))
}